import React, { useState, useImperativeHandle } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../components/forms/InputField/InputField.component';
import FormSectionHeader from '../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component';
import PurchaseOrderEquipmentInput from '../../../components/forms/lists/PurchaseOrderEquipmentInput/PurchaseOrderEquipmentInput.component';

// queries
import { GET_ALL_EQUIPMENT_FOR_SELECT_FIELD } from '../../../graphql/equipment/equipment.queries';
import { GET_ALL_JOBS_FOR_SELECT_FIELD } from '../../../graphql/job/job.queries';

// mui
import { Grid, Container } from '@mui/material';

const AddPurchaseOrder = React.forwardRef(({ errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))
    const [ selectedEquipment, setSelectedEquipment ] = useState(null)

    const formik = useFormik({
        initialValues: {
            vendorName: '',
            number: '',
            orderDate: moment(),
            job: '',
            items: [],
            equipmentSearch: '',
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>

            <InputField 
                id="vendorName"
                placeholder="Vendor Name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.vendorName}
                isValid={errors['vendorName']}
            />

            <InputField 
                id="number"
                placeholder="PO #"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.number}
                isValid={errors['number']}
            />

            <InputField 
                id="orderDate"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('orderDate', value)}
                value={formik.values.orderDate}
                isValid={errors['orderDate']}
            />

            <AsyncSelectField 
                id="job"
                value={formik.values.job}
                placeholder="Job"
                onChange={value => formik.setFieldValue('job', value.value)}
                query={{
                    query: GET_ALL_JOBS_FOR_SELECT_FIELD,
                    rules: {
                        loopField: 'allJobs',
                        label: ['name'],
                        value: 'id'
                    }
                }}
                required={false}
            />

            <FieldArray 
                name='items'
                render={({remove, push}) => (
                    <div>
                        <FormSectionHeader text='Order Items' />
                            <Grid container spacing={2} alignItems='center'>
                                <Grid item xs={10}>
                                    <AsyncSelectField 
                                        id="equipmentSearch"
                                        value={formik.values.equipmentSearch}
                                        placeholder="Select Equipment..."
                                        onChange={value => {
                                            setSelectedEquipment(value.data)
                                            formik.setFieldValue('equipmentSearch', value.value)
                                        }}
                                        query={{
                                            query: GET_ALL_EQUIPMENT_FOR_SELECT_FIELD,
                                            rules: {
                                                loopField: 'allEquipment',
                                                label: ['sku', 'name'],
                                                value: 'id',
                                                groupBy: 'category.name'
                                            }
                                        }}
                                        grouped
                                        required={false}
                                        
                                    />
                                </Grid>
                                <Grid container item xs={2}>
                                    <ActionButton sx={{ width: "100%", marginBottom: 2 }} label='Add' disabled={selectedEquipment == null} onClick={(e) => {
                                        e.preventDefault();
                                        push({...selectedEquipment, quantity: '', price: ''})
                                    }} />
                                </Grid>
                            </Grid>

                        {
                            formik.values.items.map((item, index) => {
                                return (<PurchaseOrderEquipmentInput 
                                    key={index}
                                    prefix={`items.${index}`}
                                    handleChange={formik.handleChange}
                                    name={item.name}
                                    category={[item.equipment && item.equipment.category ? item.equipment.category.name : null]}
                                    quantity={item.quantity}
                                    price={item.price}
                                    handleRemove={(e) => {
                                        e.preventDefault()
                                        remove(index)
                                    }}
                                    errors={errors['items'].length > index ? errors['items'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </form>
    </FormikProvider>)
})

export default AddPurchaseOrder